import React from 'react'
import {
  FormInputSelect,
  FormInput
} from 'camino-react'
import _ from 'lodash'

class Assignee extends React.Component {
  constructor (props) {
    super()

    this.state = {
      currentAssigneeQueues: []
    }
  }
  showTicketAssignessQueues = (assigneeId) => {
    return !_.isNil(assigneeId)
  }

  setQueues = (assigneeId) => {
    const { assignees } = this.props
    this.setState({ currentAssigneeQueues: _.find(assignees, ['value', assigneeId]).queues })
  }

  setValueOfQueue = (queue) => {
    const {
      assigneeQueueDisabled,
      queuesAssignees,
      valueOfDisabledAssigneeQueues
    } = this.props
    const { currentAssigneeQueues } = this.state
    if (assigneeQueueDisabled) {
      return _.find(queuesAssignees, ['value', valueOfDisabledAssigneeQueues])
    }

    return _.find(currentAssigneeQueues, ({ value: queue }))
  }

  assigneeOptions = () => {
    const {
      assigneeQueueDisabled,
      queuesAssignees,
      valueOfDisabledAssigneeQueues,
      assignees
    } = this.props

    if (!_.isNil(valueOfDisabledAssigneeQueues) && assigneeQueueDisabled) {
      return _.find(queuesAssignees, ['value', valueOfDisabledAssigneeQueues]).assignees
    }
    return assignees
  }

  render () {
    const {
      setQueues,
      showTicketAssignessQueues,
      setValueOfQueue,
      assigneeOptions
    } = this

    const {
      editedItem,
      assignees,
      queuesAssignees,
      assigneeQueueDisabled,
      setValueDisabledQueue,
      resetQueueToDefault
    } = this.props

    const { currentAssigneeQueues } = this.state

    return (
      <div>
        <FormInput>
          <div key={editedItem.firstValueId}>
            <div>
              <FormInputSelect
                value={_.find(assignees, ({ value: editedItem.assigneeId }))}
                isLoading={_.isEmpty(assignees)}
                options={assigneeOptions()}
                onValue={(value) => {
                  editedItem.updateOptionValue('assigneeId', value)
                  if (!assigneeQueueDisabled) {
                    resetQueueToDefault()
                    editedItem.updateOptionValue('queueId', null)
                    setValueDisabledQueue('')
                    setQueues(value)
                  }
                }}
                clearable
                name="editedItem[assigneeId]"
                id="assigneeId"
              />
            </div>
          </div>
        </FormInput>
        {showTicketAssignessQueues(editedItem.assigneeId) && (
          <div>
            <FormInput>
              <div key={editedItem.assigneeId}>
                <div>
                  <FormInputSelect
                    disabled={assigneeQueueDisabled}
                    placeholder="Queue"
                    value={setValueOfQueue(editedItem.queueId)}
                    options={currentAssigneeQueues}
                    onValue={(value) => {
                      editedItem.updateOptionValue('queueId', value)
                      setValueDisabledQueue(value)
                    }}
                    clearable
                    name="editedItem[queueId]"
                    id="editedItemQueueId"
                  />
                </div>
              </div>
            </FormInput>
          </div>
        )}
      </div>
    )
  }
}

export default Assignee
